import { trackPageView } from "lib/analytics";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ルート遷移ごとに GA4 へ page_view を送るフック。
 *
 * SPA では gtag の自動計測が初回ロードしか拾えないため、Router 配下で一度だけ呼ぶ。
 * 測定 ID 未設定の環境では trackPageView 側で no-op になる。
 * @return {void}
 */
export function useAnalyticsPageView(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);
}
